import React, { PropsWithChildren } from "react";
import cn from "classnames";
import { twMerge } from "tailwind-merge";

export type ValidationError = {
  code: string;
  detail: string;
  attr: string;
};

type Props = {
  attribute: string;
  className?: string;
  validationErrors: ValidationError[];
  isWrap?: boolean;
  wrapErrorText?: string;
};
export const ValidationInputWrapper: React.FC<PropsWithChildren<Props>> = ({
                                                                             attribute,
                                                                             className,
                                                                             validationErrors,
                                                                             isWrap = false,
                                                                             wrapErrorText,
                                                                             children
                                                                           }) => {
  let error = null;
  if (isWrap) {
    error =
      validationErrors.find((e) => {
        return e.attr?.replaceAll(/.[0-9]+(.*)/gi, "") == attribute;
      }) ?? null;
  } else {
    error = validationErrors.find((e) => e.attr == attribute) ?? null;
  }

  return (
    <>
      {children}
      <div className={cn(twMerge("text-red-500 text-xs", className))}>
        {error != null && wrapErrorText ? wrapErrorText : error?.detail}
      </div>
    </>
  );
};
